"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Cpu, BrainCircuit, BookOpen, ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const tracks = [{
  title: "Acquisto Diretto",
  description: "Diventa proprietario immediato del tuo sistema di sicurezza con un pagamento unico e garanzia completa inclusa.",
  icon: Cpu,
  link: "/ShopPage",
  animation: "group-hover:rotate-12 group-hover:scale-110"
}, {
  title: "Finanziamento",
  description: "Proteggi la tua casa oggi e paga in comode rate mensili senza pesare sul tuo budget familiare.",
  icon: BrainCircuit,
  link: "/ShopPage",
  animation: "group-hover:scale-110"
}, {
  title: "Noleggio Operativo",
  description: "La soluzione ideale per chi desidera un sistema sempre aggiornato con un canone fisso e assistenza premium.",
  icon: BookOpen,
  link: "/ShopPage",
  animation: "group-hover:-translate-y-1 group-hover:scale-110"
}];
export default function CoreIntelligenceTracks() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223718" id="opzioni-di-possesso-flessibili" className="bg-background text-foreground py-24 px-6 md:px-12 lg:px-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/10 rounded-lg blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-primary/5 rounded-lg blur-3xl pointer-events-none" />

      <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="text-center mb-16">
          <h2 className="font-default text-3xl md:text-5xl font-bold mb-6 tracking-tight text-foreground">
            Opzioni di Possesso Flessibili
          </h2>
          <p className="font-default text-muted-foreground max-w-2xl mx-auto text-lg">
            Scegli la modalità più adatta alle tue esigenze per mettere in sicurezza i tuoi spazi con la tecnologia Secureasy.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {tracks.map((track, i) => <Card key={i} data-index={i} className="group relative bg-card border-border transition-all duration-500 hover:border-primary hover:shadow-lg hover:shadow-primary/10 overflow-hidden flex flex-col h-full">
              <CardHeader className="pb-4">
                <div className="mb-6 inline-flex p-4 rounded-xl bg-primary/10 text-primary transition-colors duration-500 group-hover:bg-primary/20 w-fit">
                  <track.icon className={`w-8 h-8 transition-all duration-500 ease-out ${track.animation}`} />
                </div>
                <CardTitle className="font-default text-2xl tracking-tight text-foreground">
                  {track.title}
                </CardTitle>
              </CardHeader>
              
              <CardContent className="flex-grow pb-2">
                <CardDescription className="font-default text-base leading-relaxed text-muted-foreground group-hover:text-foreground transition-colors duration-300">
                  {track.description}
                </CardDescription>
              </CardContent>

              <CardFooter className="pt-0">
                <div className="w-full grid grid-rows-[0fr] group-hover:grid-rows-[1fr] transition-all duration-500 ease-in-out">
                  <div className="overflow-hidden">
                    <div className="pt-6 translate-y-4 group-hover:translate-y-0 transition-all duration-500 ease-out opacity-0 group-hover:opacity-100">
                      <Button asChild className="w-full group/btn border-primary/40 hover:bg-primary hover:text-primary-foreground transition-all duration-300 rounded-lg" variant="outline">
                        <Link to={track.link}>
                          Scopri di più
                          <ArrowRight className="ml-2 w-4 h-4 transition-transform duration-300 group-hover/btn:translate-x-1" />
                        </Link>
                      </Button>
                    </div>
                  </div>
                </div>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}